// extracted by mini-css-extract-plugin
export default {"pitchNumber":"PitchItem_pitchNumber__FidvM","videoLink":"PitchItem_videoLink__Vg0Ka"};